import QISignTheme from "../../../../interfaces/Theme";

export function resolveColor(key: 'primary' | 'secondary' | 'tertiary' | 'accent' | 'text', theme: QISignTheme): string {
    switch (key) {
        case "primary":
            return theme.palette?.primary ?? theme.background_color;
        case "secondary":
            return theme.palette?.secondary ?? theme.button_color;
        case "tertiary":
            return theme.palette?.tertiary ?? theme.button_font_color ?? theme.font_color;
        case "accent":
            return theme.palette?.accent ?? theme.button_font_color ?? theme.font_color;
        case "text":
            return theme.palette?.text ?? theme.font_color;
        default:
            return theme.font_color;
    }
}